/**
 * canonicalVenueId — normalise a venue row to its canonical id form
 * for backend lookups (`gplaces:<place_id>` or `lc_archive:<archive_id>`).
 *
 * Why this exists: `/api/table/browse` returns `id` as the RAW place_id
 * (e.g. `ChIJ4xN1LM9v5kcR8kqBdK645h0`) for legacy compatibility, but
 * `/api/table/venue/{id}/...` and `/api/table/venue/{id}/card.pdf`
 * require the prefixed form (`gplaces:ChIJ...`). Calling the venue
 * lookup with a raw place_id returns 404 `venue_not_found`.
 *
 * This helper makes the right call regardless of which field shape
 * the caller has — drawer rows from /browse, curate slate rows, etc.
 *
 * Filed under FIR-20260609-001 · drawer PDF download 404 in prod.
 */
export function canonicalVenueId(venue) {
    if (!venue) return null;

    // If `id` is already prefixed (`gplaces:...` or `lc_archive:...`),
    // pass it through verbatim.
    const id = venue.id;
    if (typeof id === "string" && id.includes(":")) {
        return id;
    }

    // Otherwise prefer `place_id` and prepend the gplaces marker.
    if (venue.place_id) {
        return `gplaces:${venue.place_id}`;
    }

    // Last resort · treat the bare `id` as a place_id (the /browse
    // contract emits raw place_ids in this field).
    if (id) {
        return `gplaces:${id}`;
    }

    return null;
}
